import type { TersaImageModel } from '../types';
import { providers } from '../../providers';
import { wavespeed } from '../wavespeed';

// 系数
const COST_FACTOR = 1.5;

export const fluxModels: Record<string, TersaImageModel> = {
    'flux-2-flex': {
        chef: providers['black-forest-labs'],
        providers: [
            {
                ...providers['black-forest-labs'],
                model: undefined,
                model_create: wavespeed.image('wavespeed-ai/flux-2-flex/text-to-image'),
                model_edit: wavespeed.image('wavespeed-ai/flux-2-flex/edit'),
                getCost: ({ mode } = {}) => {
                    if (mode === 'i2i') return 0.12 * COST_FACTOR;
                    return 0.06 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 3, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'flux-2-max': {
        chef: providers['black-forest-labs'],
        providers: [
            {
                ...providers['black-forest-labs'],
                model: undefined,
                model_create: wavespeed.image('wavespeed-ai/flux-2-max/text-to-image'),
                model_edit: wavespeed.image('wavespeed-ai/flux-2-max/edit'),
                getCost: () => {
                    return 0.07 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['match', '16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 3, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'flux-2-pro': {
        chef: providers['black-forest-labs'],
        providers: [
            {
                ...providers['black-forest-labs'],
                model: undefined,
                model_create: wavespeed.image('wavespeed-ai/flux-2-pro/text-to-image'),
                model_edit: wavespeed.image('wavespeed-ai/flux-2-pro/edit'),
                getCost: ({ mode } = {}) => {
                    if (mode === 'i2i') return 0.06 * COST_FACTOR;
                    return 0.03 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 3, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'flux-2-klein-9b': {
        chef: providers['black-forest-labs'],
        providers: [
            {
                ...providers['black-forest-labs'],
                model: undefined,
                model_create: wavespeed.image('wavespeed-ai/flux-2-klein-9b/text-to-image'),
                model_edit: wavespeed.image('wavespeed-ai/flux-2-klein-9b/edit'),
                getCost: ({ mode } = {}) => {
                    if (mode === 'i2i') return 0.016 * COST_FACTOR;
                    return 0.01 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['match', '16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 3, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'flux-2-klein-4b': {
        chef: providers['black-forest-labs'],
        providers: [
            {
                ...providers['black-forest-labs'],
                model: undefined,
                model_create: wavespeed.image('wavespeed-ai/flux-2-klein-4b/text-to-image'),
                model_edit: wavespeed.image('wavespeed-ai/flux-2-klein-4b/edit'),
                getCost: ({ mode } = {}) => {
                    if (mode === 'i2i') return 0.012 * COST_FACTOR;
                    return 0.008 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['match', '16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 3, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};